import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { SafeHtmlPipe } from "@intocare/pipes";

@Component({
	imports: [SafeHtmlPipe, TranslateModule],
	templateUrl: "./changelog.component.html",
	styleUrls: ["./changelog.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangelogComponent {
	@Input() changelog: string;

	@Output() closeItem = new EventEmitter<void>();
}
